export function buildFrequencyMap( values: unknown[] ): Map<string, number> {
  const freqMap = new Map<string, number>();
  for ( const v of values ) {
    if ( isNullish( v ) ) continue;
    const key = String( v );
    freqMap.set( key, ( freqMap.get( key ) || 0 ) + 1 );
  }
  return freqMap;
}

export function isNullish( v: unknown ): v is null | undefined {
  return v === null || v === undefined;
}

export function formatNum( n: number ): string {
  if ( Number.isInteger( n ) && Math.abs( n ) < 1e6 ) return n.toLocaleString();
  if ( Math.abs( n ) >= 1e6 || ( Math.abs( n ) < 0.01 && n !== 0 ) ) return n.toExponential( 2 );
  return n.toLocaleString( undefined, { maximumFractionDigits: 3 } );
}
